import React from "react";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

export default function FeatureGuideLink({ guide }) {
  if (!guide) return null;
  return <a href={guide.url} target="_blank" rel="noopener noreferrer"
    className="inline-flex items-center gap-2 rounded py-2 text-sm font-medium text-violet-700 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-violet-600">
    <span>Read the {guide.title} guide</span><OpenInNewIcon style={{ fontSize: 14, flexShrink: 0 }} />
    <span className="sr-only"> (opens in a new tab)</span>
  </a>;
}
